<script setup lang="ts">
import udlWhy from '@/assets/udl-why.svg'
import udlWhat from '@/assets/udl-what.svg'
import udlHow from '@/assets/udl-how.svg'

const BRAIN_NETWORKS = [
  { image: udlWhy, title: 'Affective Networks', keyword: 'why', keywordClass: 'text-[#078743]' },
  { image: udlWhat, title: 'Recognition Networks', keyword: 'what', keywordClass: 'text-[#6F5094]' },
  { image: udlHow, title: 'Strategic Networks', keyword: 'how', keywordClass: 'text-[#037DB8]' }
]
</script>

<template>
  <div class="flex items-start justify-center text-left">
    <div v-for="network in BRAIN_NETWORKS" :key="network.keyword" data-testid="brain-network" class="mx-4 md:mx-2">
      <div class="mb-1 uppercase tracking-[0.16px] text-gray-700">
        <span class="block text-[12px] md:text-[6px]">{{ network.title }}:</span>
        <span class="block text-[16px] md:text-[8px]">
          THE <span class="font-bold" :class="network.keywordClass">{{ network.keyword }}</span> OF LEARNING
        </span>
      </div>
      <img :src="network.image" alt="" aria-hidden="true" class="max-h-40 w-full max-w-[170px]" />
    </div>
  </div>
</template>
